import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Image } from 'semantic-ui-react';

import type { StepsConfig } from '@features/app-tour/app-tour.models';

import s from './tour-steps.scss';

const stepStyles = {
  options: {
    width: '65rem',
  },
};

const Step1 = () => {
  useStyles(s);
  return (
    <div className={classNames(s.root, s.alignLeft)}>
      <Image src="/img/robot_stig.svg" className={s.robotStig} />
      <p>
        The <strong>STIG</strong> (Security Technical Implementation Guide) tab
        is not currently enabled as this feature is only available when included
        as part of your license subscription. Please contact sales at Anchore
        for more details.
      </p>
    </div>
  );
};

export default (): StepsConfig => ({
  id: 'image',
  oneTimeOnly: true,
  steps: [
    {
      styles: stepStyles,
      content: <Step1 />,
      placement: 'bottom',
      target: '#artifactAnalysisTab-stig.disabled',
    },
  ],
});
